import { createGetEndpoint } from '@sonar-software/sonar-http';

export type BusinessContextResponse = {
	organizationId: number,
	context: string
	lastUpdatedBy: number,
	lastUpdatedAt: string,
	modelName: string,
	tokenLimit: number
};

export const getBusinessContext = createGetEndpoint<void, BusinessContextResponse>(
	'/api/v3/core/business-contexts'
);
